var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-cruise-detail-block"},[_c('h2',{staticClass:"company-cruise-detail-block-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }